import { Decoration, ViewPlugin, EditorView } from "@codemirror/view"
import { HighlightStyle, syntaxHighlighting } from "@codemirror/language"
import { tags } from "@lezer/highlight"

const nord = {
  dim: "rgba(216, 222, 233, 0.4)",
  bright: "#eceff4",
  blue: "#81a1c1",
  frost: "#88c0d0",
  teal: "#8fbcbb",
  yellow: "#ebcb8b",
  red: "#bf616a"
}

const markdownHighlight = HighlightStyle.define([
  { tag: tags.heading1, color: nord.blue, fontSize: "1.6em", fontWeight: "900", lineHeight: 1.3 },
  { tag: tags.heading2, color: nord.blue, fontSize: "1.35em", fontWeight: "700", lineHeight: 1.4 },
  { tag: tags.heading3, color: nord.blue, fontSize: "1.15em", fontWeight: "700" },
  { tag: tags.heading4, color: nord.blue, fontWeight: "700" },
  { tag: tags.heading5, color: nord.blue, fontWeight: "700" },
  { tag: tags.heading6, color: nord.blue, fontWeight: "700" },
  { tag: tags.strong, color: nord.bright, fontWeight: "700" },
  { tag: tags.emphasis, fontStyle: "italic" },
  { tag: tags.strikethrough, textDecoration: "line-through", color: nord.dim },
  { tag: tags.monospace, fontFamily: "var(--font-mono)", color: nord.yellow },
  { tag: tags.quote, color: nord.teal, fontStyle: "italic" },
  { tag: tags.link, color: nord.frost, textDecoration: "underline" },
  { tag: tags.url, color: nord.frost },
  { tag: tags.contentSeparator, color: nord.dim, fontFamily: "var(--font-mono)" },
  { tag: tags.list, color: "inherit" },
  { tag: tags.processingInstruction, color: nord.dim },
  { tag: tags.meta, color: nord.dim },
  { tag: tags.invalid, color: nord.red }
])

const HEADING_LINE = /^(#{1,6})(\s)/

const hangingHeadings = ViewPlugin.fromClass(
  class {
    constructor(view) {
      this.decorations = this.build(view)
    }

    update(update) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = this.build(update.view)
      }
    }

    build(view) {
      const decorations = []
      for (const { from, to } of view.visibleRanges) {
        let pos = from
        while (pos <= to) {
          const line = view.state.doc.lineAt(pos)
          const match = line.text.match(HEADING_LINE)
          if (match) {
            const level = match[1].length
            decorations.push(Decoration.line({ class: `cm-hang-${level}` }).range(line.from))
            decorations.push(
              Decoration.mark({ class: "cm-heading-mark" }).range(line.from, line.from + level + 1)
            )
          } else if (/^>\s?/.test(line.text)) {
            decorations.push(Decoration.line({ class: "cm-quoteline" }).range(line.from))
          }
          pos = line.to + 1
        }
      }
      return Decoration.set(decorations, true)
    }
  },
  { decorations: (plugin) => plugin.decorations }
)

export const markdownStyling = [
  syntaxHighlighting(markdownHighlight),
  hangingHeadings,
  EditorView.lineWrapping
]
